// vue-orientation.js
export default {
  install(Vue) {
    const orientation = Vue.observable({
      value: window.matchMedia('(orientation: portrait)').matches
        ? 'portrait'
        : 'landscape',
    });

    Object.defineProperty(Vue.prototype, '$orientation', {
      get() {
        return orientation.value === 'portrait';
      },
    });

    const updateOrientation = () => {
      orientation.value = window.matchMedia('(orientation: portrait)').matches
        ? 'portrait'
        : 'landscape';
    };

    window.addEventListener('orientationchange', updateOrientation);
    window.addEventListener('resize', updateOrientation);
  },
};
